<template>
     <gat-grid :items="budgetData" :columns="gridColumns" />
</template>

<script>
    import GatGrid from '@/GatComponents/GatGrid.vue';
    export default {
        name: 'CategoryBudget',
        props: ['transactions','fromDate','toDate'],
        components: {GatGrid},
        data: function() {
            return	{
                gridColumns :[ 
                    {header:"Category",field:"categoryName"},                          
                    {header:"Total in period",field:"totalInperiod"},
                    {header:"Amount pr month",field:"amountMonth"}, 
                    {header:"Budget",field:"budget"},                                                                       
                ],
            }
        },


        created(){
        },

        watch:{
        },

        computed:{
            filterDays(){
                let to = this.toDate;
                let oneDay = 24*60*60*1000; // hours*minutes*seconds*milliseconds            
                if(!this.toDate){  
                    to = new Date(1970,1,1);                        
                    this.transactions.map(trans=>{
                        if(trans.TRA_DATE > to){
                            to = trans.TRA_DATE;
                        }                
                    });
                }
                var diffDays = Math.round(Math.abs((this.fromDate.getTime() - to.getTime())/(oneDay)));
                return diffDays+1;
            },

            budgetData(){
                let result = [];
                let rootCats =  this.$store.state.categories.filter(category=>{
                    return category.CAT_PARENT_ID == null;
                });

                rootCats = rootCats.sort((a,b)=>{
                    return a.CAT_SORT - b.CAT_SORT;
                });

                rootCats.map(cat=>{                    
                    let total = this.getAmountForCategory(cat,this.transactions);
                    result.push({   'categoryName':cat.CAT_NAME,
                                    'budget':cat.CAT_BUDGET,
                                     'amountMonth':this.formatCurrency((total/this.filterDays)*365/12),
                                    // 'amountMonth':this.filterDays,
                                    'totalInperiod':this.formatCurrency(total)
                                    });
                });

                result = result.filter(item=>{
                    return item.budget !== 0;
                })
                
               
                return result;
            }
        },

        methods:{
            formatCurrency(amount){
                return new Intl.NumberFormat('no-NO', { style: 'currency', currency: 'NOK' }).format(amount) 
            },

            getAmountForCategory(category,transactions){
                let catTrans  = transactions.filter(trans=>{
                    return this.isChildOrCategory(trans.TRA_CAT_ID,category);
                })

                let result = 0;
                catTrans.map(trans=>{
                    result = result+trans.TRA_AMOUNT;
                });
                return result;
            },

            getCategoryFromId(catId){                 
                let result = this.$store.state.categories.find(item=>{
                    return item.CAT_ID == catId;
                })
                if(result){
                    return result;
                } else{
                    return null;
                }                
            },

            isChildOrCategory(catId,category){
                 if(category.CAT_ID == catId){
                     return true;
                 }
                 let childCategory = this.getCategoryFromId(catId);

                if(childCategory){                
                    if(childCategory.CAT_PARENT_ID == category.CAT_ID){
                        return true
                    }

                    if(childCategory.CAT_PARENT_ID == null){
                        return false;
                    } else{
                        return this.isChildOrCategory(childCategory.CAT_PARENT_ID,category);
                    }
                } else {
                    return false;
                }

                 

             },

        },
    }
</script>

<style scoped>

</style>
